import "./Trainer.module.css";
import Header from "@/reusable_sections/Header";
import TrainerOverview from "./sections/TrainerOverview";
import Achievements from "./sections/Achievements";
import RegisterForTheHackathon from "./sections/RegisterForTheHackathon";
import Footer from "@/reusable_sections/Footer";
export default function TrainerPage() {
  return <div>
      <Header />
      <TrainerOverview />
      <Achievements />
      <RegisterForTheHackathon />
      <Footer />
    </div>;
}